export default __webpack_public_path__ + "static/fonboarding2-8f3a7dd21039c31661029265b3e748a9.jpg";